__webpack_require__.p = "/puzzle-2048/";